import { Tooltip } from "@mui/material";
import { Organization } from "../../../core/models/entities/Organization";

interface CustomerTooltipProps {
  customer?: Organization | null;
}

export default function CustomerTooltip({ customer }: CustomerTooltipProps) {
  const name = customer?.name ?? "";
  const navNumber = customer?.navNumber ?? "";
  const tooltipTitle = customer
    ? customer.isVendor
      ? `${name} (${navNumber})`
      : name
    : "Customer information unavailable";

  return (
    <Tooltip title={tooltipTitle} placement={"top-start"}>
      <span className={"whitespace-nowrap overflow-x-hidden overflow-ellipsis"}>
        {name}
      </span>
    </Tooltip>
  );
}
